import { useQuery } from '@tanstack/react-query';
import { fetchContent } from '../../services/content/contentService';
import { getCurrentLanguage } from '@/i18n/i18nCore';

/**
 * Fetches a managed content page/collection by slug for the current UI language.
 * Used by the customer web pages (FAQ, and — once PR #270 lands — legal/contacts).
 */
export function useContent(slug: string) {
  const lang = getCurrentLanguage();
  return useQuery({
    queryKey: ['content', slug, lang],
    queryFn: () => fetchContent(slug, lang),
    staleTime: 60_000,
    retry: 1,
  });
}
